<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    headerLabel="Adicionar Processos",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selectItem="SELECIONA_PROCESSO"
  )
  .margin-bottom
    span.padding-left {{ 'Processos Selecionados: ' + processos.length }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default

export default {
  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('AGUARDANDO_OS'),
      items: [],
      totalElements: 0,
      showModalVisualizarProcesso: false,
      processoSelecionados: [],
      configuracaoFiltro: {
        filtroSituacao: [
        ],
        filtroResponsavel: [
        ],
        filtroReceita: [
        ],
        filtroMunicipio: [
          'COORDENADOR_CAF'
        ],
        filtroOrdemServico: [
        ],
        filtroFuncao: [
        ]
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => true, ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 5, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        {
          id: 5, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 2, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso }

          ]
        }
      ]
    }
  },

  async created () {
    this.initCriarOs((items) => {
      items.map(p => {
        p.selecionado = !!this.processos.find(process => process.id === p.id)
        return p
      })

      return items
    })

    if (this.processos?.length > 0) {
      this.processoSelecionados = this.processos
    }
  },

  computed: {
    ...mapState({
      processos: state => state.ordemServico.processos
    })
  },

  methods: {
    ...mapActions({
      setProcessoSelecionados: 'ordemServico/setProcessoSelecionados'
    }),

    SELECIONA_PROCESSO (item) {
      if (!this.processoSelecionados.find(p => p.id === item.id)) {
        item.selecionado = true
        this.processoSelecionados.push(item)
      } else {
        this.processoSelecionados.splice(this.processoSelecionados.findIndex((element) => {
          return element.id === item.id
        }), 1)
      }
      const processos = [...this.processoSelecionados]
      this.setProcessoSelecionados({ processos: processos, map: true })
      if (!this.processoSelecionados.find(p => p.id === item.id)) {
        item.selecionado = false
      }
    },

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },

    VISUALIZAR_COM_MODAL: (context) => {
      this.showModalResponsavel = true
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin: 20px;
}

.margin-bottom {
  margin-bottom: 10px;
}

.padding-left {
  padding-left: 25px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaProcessoOs.vue